import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  text: {
    cursor: 'unset'
  },
  textHover: {
    cursor: 'pointer'
  }
}));